export default {
    name: 'Header',
}
